module.exports = __webpack_public_path__ + "static/media/onesignal-logo.2dcf821e.png";